import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, forkJoin } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppService } from 'src/app/app.service';

@Component({
  selector: 'app-academic-wings-bangla-version',
  templateUrl: './academic-wings-bangla-version.component.html',
  styleUrls: ['./academic-wings-bangla-version.component.scss']
})
export class AcademicWingsBanglaVersionComponent implements OnInit, OnDestroy {
  TeacherInfo: any[] = [];
  fetchinData = true;
  private ngUnsubscribe = new Subject();

  constructor(private appService: AppService, private _changeDetectorRef: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.FetchTeacherInfo();
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next(null);
    this.ngUnsubscribe.complete();
  }

  FetchTeacherInfo() {
    this.fetchinData = true;
    forkJoin([
      this.appService.getTeaherStaff(),
    ]).pipe(takeUntil(this.ngUnsubscribe)).subscribe((response: any) => {
      const allData = response[0].data || [];
      this.TeacherInfo = allData.filter((x: any) => {
        const arena = (x.JobArena || x.jobArena || '').toString().trim().toLowerCase();
        return arena === 'academic wings bangla version';
      });
      this.fetchinData = false;
      this._changeDetectorRef.markForCheck();
    });
  }
}
